<template>
    <b-overlay :show="mapLoading" bg-color="transparent" blur="2px">
        <!-- LOADING OVERLAY -->
        <template #overlay>
            <div v-if="mapLoading" class="text-center py-3">
                <img src="@/assets/lottie/plant.gif" alt="Loading..." style="width: 40px;" />
            </div>
        </template>
        <b-card no-body class="rounded-xl mb-5">
            <b-card-header class="border-2 border-bottom px-5 pt-0 pb-3 d-flex align-items-center" v-if="title">
                <h3>{{ title }}</h3>
            </b-card-header>
            <!-- CONTENT -->
            <b-card-body class="p-0">
                <div class="map-wrapper" style="height: 400px; width: 100%; position: relative;">
                    <template v-if="!isMapLoaded">
                        <div
                            class="d-flex align-items-center justify-content-center"
                            style="height: 100%; width: 100%; background: rgba(0,0,0,0.2); border-radius: 10px; overflow: hidden;"
                        >
                            <div
                            class="buka-map-btn text-center py-3 px-4 bg-light text-primary rounded shadow-sm"
                            style="cursor: pointer;"
                            @click="loadMap"
                            >
                            Buka Maps
                            </div>
                        </div>
                    </template>

                    <div
                    v-else
                    ref="mapContainer"
                    style="height: 100%; width: 100%; border-radius: 10px;"
                    ></div>
              </div>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import JSZip from "jszip";
export default {
  name: "single-polygon-loader",
  components: {
  },
  props: {
    title: { type: String, default: null },
    coordinate_data: { type: Object, default: {latitude: -7.024947, longitude: 110.414672} },
    polygon_data: { type: Object, default: null },
  },
  data() {
    return {
      mapLoading: false,
      maps: null,
      isMapLoaded: false,
    };
  },

  mounted() {
  },
  methods: {
    async publicLoadMap() {
      this.loadMap();
    },
    async loadMap() {
      this.mapLoading = true;
      this.isMapLoaded = true;
      this.$nextTick(async () => {
        if (!this.coordinate_data || !this.coordinate_data.latitude || !this.coordinate_data.longitude) {
          return;
        }
        await this.initializeMap();
      });
      this.mapLoading = false;
    },
    async initializeMap() {
      let mapLatitude = this.coordinate_data.latitude || null;
      let mapLongitude = this.coordinate_data.longitude || null;

      if (!mapLatitude || !mapLongitude) {
        this.$_alert.success(`Tidak ada data koordinat!`);
        return;
      }

      this.maps = new mapboxgl.Map({
        accessToken: this.$_config.apikey.mapbox,
        container: this.$refs.mapContainer,
        style: "mapbox://styles/mapbox/satellite-streets-v12",
        center: [mapLongitude, mapLatitude],
        zoom: 12,
        projection: "globe",
      });

      this.maps.addControl(new mapboxgl.NavigationControl());
      this.maps.addControl(new mapboxgl.FullscreenControl());

      new mapboxgl.Marker({ color: "red" })
        .setLngLat([mapLongitude, mapLatitude])
        .addTo(this.maps);

      if (this.polygon_data && this.polygon_data.url && this.polygon_data.ext) {
        await this.loadPolygonLayer(this.polygon_data.url);
      } else {
        this.$_alert.info(`Tidak Ada Data Polygon`);
      }
    },
    async loadPolygonLayer(fileUrl) {
      try {
        const res = await fetch(fileUrl);
        const blob = await res.blob();
        const ext = this.polygon_data.ext.toLowerCase();

        let geojson = null;

        if (ext === "kml") {
          const text = await blob.text();
          const parser = new DOMParser();
          const kmlDoc = parser.parseFromString(text, "application/xml");
          geojson = window.toGeoJSON.kml(kmlDoc);
        } else if (ext === "kmz") {
          try {
            const arrayBuffer = await blob.arrayBuffer();
            const zip = await JSZip.loadAsync(arrayBuffer);
            const kmlFile = Object.keys(zip.files).find((f) => f.endsWith(".kml"));
            const kmlText = await zip.files[kmlFile].async("string");

            const parser = new DOMParser();
            const kmlDoc = parser.parseFromString(kmlText, "application/xml");

            console.log("kmlDoc", kmlDoc);

            const geojson = toGeoJSON.kml(kmlDoc);
            console.log("geojson", geojson);

            if (geojson.features && geojson.features.length) {
              geojson.features.forEach((feature) => {
                if (feature.geometry && feature.geometry.type === "Polygon") {
                  this.maps.addSource("uploaded-polygon", {
                    type: "geojson",
                    data: feature,
                  });

                  this.maps.addLayer({
                    id: "uploaded-polygon",
                    type: "fill",
                    source: "uploaded-polygon",
                    layout: {},
                    paint: {
                      "fill-color": "#ff0000",
                      "fill-opacity": 0.4,
                    },
                  });

                  const bounds = new mapboxgl.LngLatBounds();
                  feature.geometry.coordinates[0].forEach(([lng, lat]) =>
                    bounds.extend([lng, lat])
                  );
                  this.maps.fitBounds(bounds, { padding: 30 });
                }
              });
            } else {
              console.warn("No features found in KML!");
            }
          } catch (err) {
            console.error("Failed to load polygon:", err);
          }

        }

        if (geojson) {
          this.addGeoJSONToMap(geojson);
        }
      } catch (err) {
        console.error("Failed to load polygon:", err);
      }
    },
    addGeoJSONToMap(geojson) {
      if (!this.maps.getSource("mangrove-polygon")) {
        this.maps.addSource("mangrove-polygon", {
          type: "geojson",
          data: geojson,
        });

        this.maps.addLayer({
          id: "mangrove-polygon-fill",
          type: "fill",
          source: "mangrove-polygon",
          paint: {
            "fill-color": "#ff0000",
            "fill-opacity": 0.4,
          },
        });

        this.maps.addLayer({
          id: "mangrove-polygon-outline",
          type: "line",
          source: "mangrove-polygon",
          paint: {
            "line-color": "#ff0000",
            "line-width": 2,
          },
        });

        // fit bounds
        const bounds = new mapboxgl.LngLatBounds();
        geojson.features.forEach((feature) => {
          const coords = feature.geometry.coordinates.flat(2);
          coords.forEach(([lng, lat]) => bounds.extend([lng, lat]));
        });
        this.maps.fitBounds(bounds, { padding: 50 });
      }
    },
  },
  
};
</script>
<style>
.map-placeholder {
  background: url('https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/110.4, -7.02,9,0/800x400?access_token=YOUR_MAPBOX_KEY') center/cover no-repeat;
  filter: blur(5px) brightness(0.8);
}
</style>


// WEBPACK FOOTER //
// src/base/component/single-polygon-loader.vue